

/// <reference path="CoreAccounting.ts" />

// Generated class BankAccount_ManagedObject

class BankAccount_ManagedObject extends CoreAccounting
{

    // Property: apiReference
    set apiReference(value:string) {
        this.setValueForKey(value, 'apiReference');
    }
    get apiReference():string {
        return this.valueForKey('apiReference');
    }
    set apiReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'apiReference');
    }
    get apiReferencePrimitiveValue():string {
        return this.primitiveValueForKey('apiReference');
    }

    // Property: balance
    set balance(value:number) {
        this.setValueForKey(value, 'balance');
    }
    get balance():number {
        return this.valueForKey('balance');
    }
    set balancePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'balance');
    }
    get balancePrimitiveValue():number {
        return this.primitiveValueForKey('balance');
    }

    // Property: externalReference
    set externalReference(value:string) {
        this.setValueForKey(value, 'externalReference');
    }
    get externalReference():string {
        return this.valueForKey('externalReference');
    }
    set externalReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'externalReference');
    }
    get externalReferencePrimitiveValue():string {
        return this.primitiveValueForKey('externalReference');
    }

    // Property: type
    set type(value:number) {
        this.setValueForKey(value, 'type');
    }
    get type():number {
        return this.valueForKey('type');
    }
    set typePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'type');
    }
    get typePrimitiveValue():number {
        return this.primitiveValueForKey('type');
    }
    // Relationship: bank
    set bank(value:Bank) {
        this.setValueForKey(value, 'bank');
    }
    get bank():Bank {
        return this.valueForKey('bank') as Bank;
    }
    // Relationship: info
    set info(value:BankAccountInfo) {
        this.setValueForKey(value, 'info');
    }
    get info():BankAccountInfo {
        return this.valueForKey('info') as BankAccountInfo;
    }
    // Relationship: mappingInfo
    set mappingInfo(value:IntegratorMappingInfo) {
        this.setValueForKey(value, 'mappingInfo');
    }
    get mappingInfo():IntegratorMappingInfo {
        return this.valueForKey('mappingInfo') as IntegratorMappingInfo;
    }
    // Relationship: movementBalance
    set movementBalance(value:BankMovementBalance) {
        this.setValueForKey(value, 'movementBalance');
    }
    get movementBalance():BankMovementBalance {
        return this.valueForKey('movementBalance') as BankMovementBalance;
    }
}
